<template>
  <div class="container">
    <div class="handle-box">
      <el-input
        size="small"
        placeholder="输入所属用户名称或举报人名称"
        v-model.trim="name"
        class="handle-input mr10"
      ></el-input>
      <el-select size="small" v-model="reportType" class="mr10">
        <el-option
          v-for="item in typeOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <el-select size="small" v-model="reportLocation" class="mr10">
        <el-option
          v-for="item in locationOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <el-select size="small" v-model="auditStatus" class="mr10">
        <el-option
          v-for="item in statusOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
    </div>
    <el-table :data="data.records" border style="width: 100%">
      <el-table-column
        prop="reportType"
        :formatter="formatterType"
        label="举报类型"
        header-align="center"
      />

      <el-table-column
        prop="reportLocation"
        label="举报位置"
        :formatter="formatterLocation"
        align="center"
        show-overflow-tooltip
      />
      <el-table-column prop="beReporterName" label="所属用户" align="center" />
      <el-table-column label="举报详情" align="center">
        <template #default="scope">
          <el-button type="text" @click="infoData(scope.row)"
            >查看全部</el-button
          >
        </template>
      </el-table-column>
      <el-table-column prop="reporterName" label="举报人" align="center" />

      <el-table-column
        prop="reportTime"
        label="举报时间"
        width="180"
        align="center"
      />
      <el-table-column label="处理状态" width="100" align="center">
        <template #default="scope">
          <el-tag v-if="scope.row.auditStatus === 0" size="small" type="danger"
            >待处理</el-tag
          >
          <el-tag v-if="scope.row.auditStatus === 1" size="small" type="success"
            >已处理</el-tag
          >
          <el-tag v-if="scope.row.auditStatus === 2" size="small" type="warning"
            >无效举报</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="240">
        <template #default="scope">
          <el-button
            type="primary"
            size="mini"
            v-if="scope.row.auditStatus === 0"
            @click="handleData(scope.row, 1)"
            >受理</el-button
          >
          <el-button
            type="warning"
            size="mini"
            v-if="scope.row.auditStatus === 0"
            @click="handleData(scope.row, 2)"
            >无效</el-button
          >
          <el-button
            type="danger"
            v-if="scope.row.auditStatus === 2"
            size="mini"
            @click="delData(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination
        background
        layout="total, prev, pager, next"
        :current-page="data.current"
        :page-size="20"
        :total="data.total"
        @current-change="getData"
      ></el-pagination>
    </div>

    <!-- 详情 -->
    <el-dialog
      width="700px"
      title="举报详情"
      v-model="dialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="dialog-body">
        <li class="title">举报信息：</li>
        <table>
          <tbody>
            <tr>
              <td>举报类型：</td>
              <td>{{ formatterType(itemData) }}</td>
            </tr>
            <tr>
              <td>举报人：</td>
              <td>{{ itemData.reporterName }}</td>
            </tr>
            <tr>
              <td>举报时间：</td>
              <td>{{ itemData.reportTime }}</td>
            </tr>
            <tr>
              <td>说明：</td>
              <td>{{ itemData.reportExplain }}</td>
            </tr>
          </tbody>
        </table>
        <li class="title">被举报信息：</li>
        <table>
          <tbody>
            <tr>
              <td>举报位置：</td>
              <td>{{ formatterLocation(itemData) }}</td>
            </tr>
            <tr>
              <td>所属用户：</td>
              <td>{{ itemData.beReporterName }}</td>
            </tr>
            <tr>
              <td>被举报内容：</td>
              <td>
                <p v-if="itemData.reportLocation === 1">
                  <template v-if="itemData.reportLocationType === 1">
                    页面链接：<a
                      :href="`https://www.dajiaxinfu.com${itemData.reportContent}`"
                      target="_blank"
                      >{{ itemData.reportContent }}</a
                    >
                  </template>
                  <template v-else>
                    {{ itemData.reportContent }}
                  </template>
                </p>
                <p
                  v-else-if="
                    itemData.reportLocation === 2 ||
                    itemData.reportLocation === 9
                  "
                >
                  {{ itemData.reportContent }}
                </p>
                <p v-else>
                  页面链接：<a
                    :href="`https://www.dajiaxinfu.com${itemData.reportContent}`"
                    target="_blank"
                    >{{ itemData.reportContent }}</a
                  >
                </p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <template #footer>
        <span class="dialog-footer">
          <el-button type="primary" @click="dialogVisible = false"
            >关闭</el-button
          >
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { reactive, ref, toRefs, watch } from "vue";
import { ElMessage, ElMessageBox } from "element-plus";
import NProgress from "nprogress";
import api from "./../../api/index.js";
export default {
  setup() {
    let loading = false;
    let name = ref("");
    let reportType = ref("");
    let reportLocation = ref("");
    let auditStatus = ref("");
    let dialogVisible = ref(false);
    const typeOptions = reactive([
      { label: "全部", value: "" },
      { label: "广告", value: 1 },
      { label: "内容低俗", value: 2 },
      { label: "题文不符", value: 3 },
      { label: "重复、旧闻", value: 4 },
      { label: "时政信息不实", value: 5 },
      { label: "涉嫌违法犯罪", value: 6 },
      { label: "其他", value: 7 },
    ]);
    const locationOptions = reactive([
      { label: "全部", value: "" },
      { label: "个人动态及评论", value: 1 },
      { label: "个人评价及回复", value: 2 },
      { label: "融资项目详情页内容", value: 3 },
      { label: "线上培训课程", value: 5 },
      { label: "线下活动", value: 6 },
      { label: "诚信承诺", value: 7 },
      // { label: "新闻资讯", value: 8 },
      { label: "多元评价内容", value: 9 },
    ]);
    const statusOptions = reactive([
      { label: "全部", value: "" },
      { label: "待处理", value: 0 },
      { label: "已处理", value: 1 },
      { label: "无效举报", value: 2 },
    ]);
    let itemData = reactive({ itemData: {} });
    let data = reactive({ data: { records: [] } });
    // 查询数据
    const getData = async (page = 1) => {
      if (name.value.length > 30) {
        ElMessage.warning("搜索内容最多输入30个字");
        return;
      }

      const params = {
        name: name.value,
        reportType: reportType.value,
        reportLocation: reportLocation.value,
        auditStatus: auditStatus.value,
        currentPage: page,
        pageSize: 20,
      };
      try {
        NProgress.start();
        const res = await api.report.getData(params);
        NProgress.done();
        if (res.code === 10200) {
          data.data = res.data;
        } else {
          ElMessage.error(res.msg);
        }
      } catch (error) {
        NProgress.done();
      }
    };
    getData();
    //举报类型格式
    const formatterType = (data) => {
      switch (data.reportType) {
        case 1:
          return "广告";
        case 2:
          return "内容低俗";
        case 3:
          return "题文不符";
        case 4:
          return "重复,旧闻";
        case 5:
          return "时政信息不实";
        case 6:
          return "涉嫌违法犯罪";
        case 7:
          return "其他";
      }
    };
    // 举报位置格式
    const formatterLocation = (data) => {
      switch (data.reportLocation) {
        case 1:
          return "个人动态及评论";
        case 2:
          return "个人评价及回复";
        case 3:
          return "融资项目详情页内容";
        case 4:
          return "投资机构详情页内容";
        case 5:
          return "线上培训课程";
        case 6:
          return "线下活动";
        case 7:
          return "诚信承诺";
        case 8:
          return "新闻资讯";
        case 9:
          return "多元评价内容";
      }
    };
    // 搜索触发事件
    watch([name, reportType, reportLocation, auditStatus], () => {
      getData();
    });
    // 处理举报
    const handleData = async (data, status) => {
      const text =
        status === 1
          ? "是否通过本条举报信息，并对被举报内容进行禁止展示处理？"
          : "是否将本条举报设为无效？";
      ElMessageBox.confirm(text, {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          submitHandle(data, status);
        })
        .catch(() => {});
    };
    // 提交处理
    const submitHandle = async (data, status) => {
      const params = {
        id: data.id,
        auditStatus: status,
        reportLocationType: data.reportLocationType,
        beReportedId: data.beReportedId,
      };
      if (!loading) {
        try {
          loading = true;
          NProgress.start();
          const res = await api.report.handleData(params);
          loading = false;
          NProgress.done();
          if (res.code === 10200) {
            getData();
            ElMessage.success("操作成功！");
          } else {
            ElMessage.error("操作失败！");
          }
        } catch (error) {
          loading = false;
          NProgress.done();
        }
      }
    };
    const delData = (data) => {
      ElMessageBox.confirm("是否将本条举报记录删除？", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          submitDel(data);
        })
        .catch(() => {});
    };
    const submitDel = async (data) => {
      if (!loading) {
        try {
          loading = true;
          NProgress.start();
          const res = await api.report.delData(data.id);
          loading = false;
          NProgress.done();
          if (res.code === 10200) {
            getData();
            ElMessage.success("删除成功！");
          } else {
            ElMessage.error("删除失败！");
          }
        } catch (error) {
          loading = false;
          NProgress.done();
        }
      }
    };
    const infoData = (data) => {
      itemData.itemData = data;
      dialogVisible.value = true;
    };
    return {
      name,
      reportType,
      typeOptions,
      reportLocation,
      locationOptions,
      auditStatus,
      statusOptions,
      dialogVisible,
      ...toRefs(data),
      ...toRefs(itemData),
      getData,
      formatterType,
      formatterLocation,
      handleData,
      delData,
      infoData,
    };
  },
};
</script>

<style lang="scss" scoped>
.handle-box {
  display: flex;
  margin-bottom: 24px;
  .handle-input,
  .el-select {
    max-width: 300px;
    display: inline-block;
  }
}
.dialog-body {
  .title {
    font-size: 1rem;
    line-height: 40px;
    color: $--color-text-primary;
  }

  table {
    width: 100%;
    border: 1px solid $--border-color-base;

    td {
      line-height: 40px;
      padding: 0 10px;
      border: 1px solid $--border-color-base;

      &:first-child {
        width: 90px;
        text-align: right;
      }

      a {
        color: $--color-primary;
      }

      p {
        line-height: 24px;
      }
    }
  }
}
</style>